import React, { useContext } from 'react'
import { Form, Button, Modal, InputNumber, Select} from 'antd';
import { appContext } from "./../../../../AppContext";
import { IsStormvloed } from '@utils';
const { Option } = Select;


export default function AddRaceSkillPointModal({
    isModalVisible, 
    setIsModalVisible, 
    newRaceSkillPoints, 
    setNewRaceSkillPoints
}){
    const layout = useFormLayout();
    const [appState] = useContext(appContext);
    const isStormvloed = IsStormvloed(appState.storyName)

    const [form] = Form.useForm()

    function handleOk() {
        setIsModalVisible(false);
    }

    function handleCancel() {
        setIsModalVisible(false);
    }

    const skillPointTypeOptions = appState.skillPointTypes.map(_ => {
        return (<Option 
          value={_.id} 
          key={_.id}
        >
          {_.name}
        </Option>)
      })

    return (
            <Modal 
                title="Add Race skillpoint" 
                visible={isModalVisible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                footer={null}
                width={"80%"}
            >
                <Form 
                    {...layout}
                    name="basic"
                    layout="horizontal"
                    onFinish={onAdd}
                    form={form}
                    >

                    <Form.Item
                        label="Amount"
                        name="amount"
                    >
                        <InputNumber defaultValue={1} name="amount" />
                    </Form.Item>
                    
                    <Form.Item
                        label="Skillpoint type"
                        name="skillPointType"
                    >
                        <Select 
                            allowClear
                            name="skillPointType" 
                            defaultValue={appState.skillPointTypes[0]?.id}
                            disabled={!isStormvloed}
                        >
                            {skillPointTypeOptions}
                        </Select>
                    </Form.Item>
                    <Form.Item >
                        <Button type="primary" htmlType="submit">
                        Add skillpoints to this {isStormvloed ? "race" : "world"}
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>
    )

    function onAdd(values)
    {
        const newList = [
            ...newRaceSkillPoints,
            {
                amount:values.amount ?? 1,
                skillPointTypeId:values.skillPointType ?? appState.skillPointTypes[0].id
            }
        ]
        setNewRaceSkillPoints(newList);
        setIsModalVisible(false);
        form.resetFields();

    }

    function useFormLayout()
    {
        return {
            hideRequiredMark: true,
            colon: false,
            layout:"inline"
        }
    }
}